import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "YOUR_API_KEY",
  authDomain: "travixra.firebaseapp.com",
  projectId: "travixra",
  storageBucket: "travixra.appspot.com",   // ✅ FIXED
  messagingSenderId: "287806736598",
  appId: "1:287806736598:web:2a021613d28b386440a177",
  measurementId: "G-Y02G7W22QJ"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);   // ✅ ADD THIS

getAnalytics(app);